import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_DELIVERY_PRICE,
  CLEAR_DELIVERY_PRICES,
  FLAG_GETTING_DELIVERY_PRICES,
  FLAG_DELIVERY_PRICE_ACTIVITY,
  GET_DELIVERY_PRICE,
  GET_DELIVERY_PRICES,
} from '../../../actions/types/cargo/DeliveryPrice';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DELIVERY_PRICES:
      return state.setIn(['all', 'loading'], payload);
    case GET_DELIVERY_PRICES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DELIVERY_PRICES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DELIVERY_PRICE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DELIVERY_PRICE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DELIVERY_PRICE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
